import { transformDateValue } from 'core/js/FormUtils';
export const getProduct2skill2exp2rateView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let product2skill2exp2rateList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"Type Id","fieldValue":transformDataValue(data.typeid,"number"), "fieldType":"number"},
              
              
            ],
            'dataList': [
                
              ]
          }

          product2skill2exp2rateList.push(card);
  })
  return product2skill2exp2rateList;
}